import React, { useState } from 'react'
import LineUpHome from './LineUpHome'
import LineUpAway from './LineUpAway'

export default function LineUp() {
    const [Homerenk , Homesetrenk] = useState("#a41d34")
    const [Homerenk2 , Homesetrenk2] = useState("#14c0f1")
    const [Awayrenk , Awasetrenk] = useState("#163962")
    const [Awarenk2 , Awasetrenk2] = useState("#ffed00")
    const [lineStyle , setlineStyle] = useState("4-3-3")

  return (
    <div className='TeamsLineUp'>
    <div className='TeamsLineUpArea'>
         <LineUpHome/>
         <div className='TeamsLineUpSpan'></div>
         <LineUpAway/>

    </div>
    </div>
  )
}
